function setRedirectURL(data) {
  return {
    type: 'REDIRECT_URL_SET',
    data,
  };
}

export {setRedirectURL};
